<template>
    <b-form-group>
        <div class="element_holder_sunbit">
            <div id="payment-element"></div>
        </div>
    </b-form-group>
</template>
<style type="text/css" lang="scss">
.element_holder_sunbit {
    display: flex;
    flex-direction: row-reverse;
    width: 26.5rem;
}
.element_label {
    width: 26%;
    height: 120px;
    float: left;

    label {
        margin-top: 11px;
        margin-bottom: 10px;
    }
}

#payment-element {
    width: 71%;
}

label[for="save_card"] {
    margin-top: 1px;
}
</style>
<script>
import PaymentDialogHelper from "@/module/payment/helper.js";
import { debounce, get } from "lodash";

export default {
    name: "StripeElements",
    props: {
        data: {
            type: Object,
            default() {
                return {};
            }
        },
        metadata: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    mixins: [PaymentDialogHelper],
    data() {
        return {
            stripe: null,
            elements: null,
            paymentIntentId: null,
            termTextShow: false,
            clinicName: ""
        };
    },
    mounted() {
        let self = this;
        self.clinicName = get(this, "$root.setting.business.name");
        if (!self.data.isPayNow) {
            // eslint-disable-next-line no-undef
            self.data.stripe = Stripe(
                _.get(self, "$root.cc_extension.STRIPE_PUBLIC_KEY", ""),
                {
                    stripeAccount: _.get(
                        self,
                        "$root.cc_extension.STRIPE_ACCOUNT_ID",
                        ""
                    )
                }
            );

            self.initializeStripe();
        } else {
            self.getStripeDetails();
        }
    },
    methods: {
        async getStripeDetails() {
            let self = this;
            await self
                ._getStripeDetails(self.data.business_id)
                .then(function (response) {
                    // eslint-disable-next-line no-undef
                    self.data.stripe = Stripe(response.public_key, {
                        stripeAccount: response.account_id
                    });
                    self.initializeStripe();
                });
        },
        async initializeStripe() {
            let self = this;
            if (self.data.trans_type != "payment_method") {
                self.data.save_card = 1;
            }
            let metadata = self._generateMetadata(
                {
                    ...self.metadata,
                    userId: self.$root.currentActor.id
                },
                self.metadata.is_census
            );

            let trans_type = "payment";
            self.$emit("isElementsLoaded", false);

            self.$http
                .post(process.env.BARRAMUNDI + "payment/stripe/secret", {
                    amount: self.data.payment_amount,
                    client_id: self.data.client
                        ? self.data.client.id
                        : self.data.client_id,
                    trans_type: trans_type,
                    business_id: self.data.business_id,
                    input_metadata: metadata,
                    payment_method_type: "sunbit"
                })
                .then(function (response) {
                    if (response.data.response.client_secret) {
                        let clientSecret = response.data.response.client_secret;
                        self.paymentIntentId =
                            response.data.response.transaction_id;
                        const options = {
                            clientSecret: clientSecret
                        };

                        self.data.elements = self.data.stripe.elements(options);

                        const paymentElementOptions = {
                            layout: "accordion"
                        };
                        const paymentElement = self.data.elements.create(
                            "payment",
                            paymentElementOptions
                        );
                        paymentElement.mount("#payment-element");

                        paymentElement.on("ready", function (event) {
                            self.$emit("isElementsLoaded", true);
                            self.$emit("isDisableSave", false);
                        });
                        paymentElement.on("loaderror", function (event) {
                            self.$emit("isElementsLoaded", true);
                            self.$emit("isDisableSave", true);
                            self._message(event.error.message, "danger");
                        });
                    } else {
                        self.data.myerror =
                            response.data.response.message.description;
                        self.$emit("isElementsLoaded", true);
                        self.$emit("isDisableSave", true);
                        self._message("Error initializing payment", "danger");
                    }
                });
        },
        async confirmPaymentStripe() {
            let self = this;
            const stripe = self.data.stripe;
            const elements = self.data.elements;
            const returnUrl = window.location.href;

            const response = await stripe.confirmPayment({
                elements,
                confirmParams: {
                    return_url: returnUrl
                }
            });

            if (response.error) {
                console.error("Error:", response.error);
            }
        },
        handlePaymentAmountChange(amount) {
            this.data.myerror = "";
            if (this.paymentIntentId) {
                this.updatePaymentIntent(this.paymentIntentId, amount);
            } else {
                this.initializeStripe();
            }
        },
        async updatePaymentIntent(paymentIntentId, amount) {
            let self = this;
            self.$emit("isIntentLoading", true);

            await self.$http.put(
                process.env.BARRAMUNDI +
                    "payment/stripe/payment-intent/" +
                    paymentIntentId,
                {
                    amount: amount,
                    business_id: self.data.business_id
                }
            );
            self.$emit("isIntentLoading", false);
        }
    },
    watch: {
        "data.payment_amount": {
            handler: debounce(function (newValue, oldValue) {
                if (
                    newValue !== null &&
                    newValue !== undefined &&
                    newValue !== "" &&
                    newValue !== 0 &&
                    newValue !== "0" &&
                    newValue > 0
                ) {
                    this.handlePaymentAmountChange(newValue);
                }
            }, 700),
            immediate: false
        }
    }
};
</script>
